export const active = state => state.active;
export const activeParams = state => state.activeParams;



// WEBPACK FOOTER //
// ./src/shared/components/modal/store/getters.js